import { IconGlobe } from '@shared/ui/v2';

/** Значок типа источника (как в макете: PDF, DOC, XLS, PPT, TXT, ZIP; сайт — глобус). */
const TYPES: Record<string, { label: string; bg: string; fg: string }> = {
  pdf: { label: 'PDF', bg: '#FEE2E2', fg: '#DC2626' },
  doc: { label: 'DOC', bg: '#E0EAFF', fg: '#1D4FA8' },
  docx: { label: 'DOC', bg: '#E0EAFF', fg: '#1D4FA8' },
  xls: { label: 'XLS', bg: '#DCFCE7', fg: '#15803D' },
  xlsx: { label: 'XLS', bg: '#DCFCE7', fg: '#15803D' },
  ppt: { label: 'PPT', bg: '#FFEDD5', fg: '#C2410C' },
  pptx: { label: 'PPT', bg: '#FFEDD5', fg: '#C2410C' },
  txt: { label: 'TXT', bg: '#F3F4F6', fg: '#374151' },
  zip: { label: 'ZIP', bg: '#F3F4F6', fg: '#374151' },
};

export function extOf(name: string | null | undefined) {
  const n = name ?? '';
  return n.includes('.') ? n.split('.').pop()!.toLowerCase() : '';
}

export function TypeBadge({
  name,
  site,
  dim,
}: {
  name?: string | null;
  site?: boolean;
  dim?: boolean;
}) {
  if (site) {
    return (
      <span className="kb-type" style={{ background: '#EFF6FF', color: '#1D4FA8' }}>
        <IconGlobe size={15} />
      </span>
    );
  }
  const ext = extOf(name);
  const t = TYPES[ext] ?? {
    label: (ext || 'FILE').slice(0, 4).toUpperCase(),
    bg: '#F3F4F6',
    fg: '#9CA3AF',
  };
  return (
    <span
      className="kb-type"
      style={dim ? { background: '#F9FAFB', color: '#9CA3AF' } : { background: t.bg, color: t.fg }}
    >
      {t.label}
    </span>
  );
}

const MSK = 'Europe/Moscow';
function parse(iso: string) {
  return new Date(/[zZ]|[+-]\d\d:?\d\d$/.test(iso) ? iso : iso + 'Z');
}

/** «26 окт, 14:30» / «сегодня, 08:31». */
export function when(iso: string | null | undefined) {
  if (!iso) return '';
  const d = parse(iso);
  const day = (x: Date) => x.toLocaleDateString('ru-RU', { timeZone: MSK });
  const time = d.toLocaleTimeString('ru-RU', { timeZone: MSK, hour: '2-digit', minute: '2-digit' });
  if (day(d) === day(new Date())) return `сегодня, ${time}`;
  return `${d.toLocaleDateString('ru-RU', { timeZone: MSK, day: 'numeric', month: 'short' }).replace('.', '')}, ${time}`;
}

/** «26 окт в 14:30». */
export function whenAt(iso: string | null | undefined) {
  return when(iso).replace(', ', ' в ');
}

export function sizeMb(bytes: number) {
  const mb = bytes / 1024 / 1024;
  return `${mb < 0.1 ? '0,1' : mb.toFixed(1).replace('.', ',')} МБ`;
}

export function pagesWord(n: number) {
  const a = n % 100;
  const b = n % 10;
  if (a > 10 && a < 20) return 'страниц';
  if (b === 1) return 'страница';
  if (b > 1 && b < 5) return 'страницы';
  return 'страниц';
}

export function imagesWord(n: number) {
  const a = n % 100;
  const b = n % 10;
  if (a > 10 && a < 20) return 'картинок';
  if (b === 1) return 'картинка';
  if (b > 1 && b < 5) return 'картинки';
  return 'картинок';
}

/** «до 31,00 ₽» / «0,50 ₽». */
export function money(v: number | string | null | undefined, upTo = false) {
  const n = Number(v ?? 0);
  const s =
    new Intl.NumberFormat('ru-RU', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(
      n,
    ) + ' ₽';
  return upTo ? `до ${s}` : s;
}
